import { createApp } from 'vue';
import CheckBalanceForm from './CheckBalanceForm.vue';
import { registerIsland } from '@/shared/islands.js';

// The Check Voucher Balance section's form. Registered rather than swept so it also mounts
// in content swapped in after first paint, the way every other island here does.
//
// Each match gets its own app, and each app builds its own voucher flow, so a page carrying
// the section twice would have two independent journeys rather than two forms fighting over
// one. That is the reason the flow became a factory - see shared/voucherFlow.js.
registerIsland('[data-check-balance]', (el) => createApp(CheckBalanceForm, {
    checkUrl: el.dataset.checkUrl,
    redeemUrl: el.dataset.redeemUrl,
}));
